/* src/index.js */

/* global document */

import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import CssBaseline from '@material-ui/core/CssBaseline';

import App from './app';
import { ErrorHandler } from './app/components/ErrorHandler';
import registerServiceWorker from './registerServiceWorker';
import configureStore from './config/store';
import { createClient } from './config/client';
import './config/firebase';
import './index.css';

const history = createBrowserHistory();
const { store } = configureStore(history);

ReactDOM.render(
  <ErrorHandler>
    <CssBaseline />
    <ApolloProvider client={createClient(store)}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>
    </ApolloProvider>
  </ErrorHandler>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js